module.exports = __webpack_public_path__ + "img/backoffice.96ce7ae6.png";